// /Users/donovan68/dva-frontend-vite/src/components/help/HelpIcon.tsx
import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface HelpIconProps {
  topicId: string;
  label?: string;
  floating?: boolean;
}

export function HelpIcon({ topicId, label, floating = false }: HelpIconProps) {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    navigate(`/help?topic_id=${topicId}`);
  };

  if (floating) {
    return (
      <div className="fixed bottom-6 right-6 z-50">
        <button
          onClick={handleClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className="group relative w-14 h-14 rounded-full bg-gradient-to-br from-[#18365E] to-[#FF6E4C] text-white shadow-lg hover:shadow-xl transition-all hover:scale-110 flex items-center justify-center"
          aria-label="Get help with Personalization"
        >
          <HelpCircle className="w-7 h-7" />
          
          {/* Pulse Animation */}
          <span className="absolute inset-0 rounded-full bg-[#FF6E4C] opacity-75 animate-ping"></span>
        </button>

        {/* Hover Tooltip */}
        {isHovered && (
          <div className="absolute bottom-full right-0 mb-3 animate-in fade-in slide-in-from-bottom-2 duration-200">
            <div className="bg-slate-900 text-white text-[13px] rounded-lg shadow-2xl px-4 py-3 whitespace-nowrap">
              <div className="font-semibold mb-1">Need help?</div>
              <div className="text-slate-300">Click for guidance</div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="relative inline-flex items-center gap-2">
      <button
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="group inline-flex items-center gap-2 px-3 py-2 rounded-lg text-[13px] font-medium text-[#18365E] hover:bg-[#18365E]/10 transition-all border border-[#18365E]/20 hover:border-[#18365E]/40"
        aria-label={label || "Get help"}
      >
        <HelpCircle className="w-4 h-4 text-[#FF6E4C]" />
        {label && <span>{label}</span>}
      </button>

      {/* Hover Tooltip */}
      {isHovered && (
        <div className="absolute top-full left-0 mt-2 z-50 animate-in fade-in slide-in-from-top-1 duration-200">
          <div className="bg-slate-900 text-white text-xs rounded-lg shadow-xl px-3 py-2 whitespace-nowrap">
            <div className="font-medium mb-1">Need help with Personalization?</div>
            <div className="text-slate-300 flex items-center gap-1">
              Click to learn more
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}